module.exports = __webpack_public_path__ + "static/img/iEP-4.086875f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/iEP-4.jpg
// module id = vTAu
// module chunks = 1